module.exports = __webpack_public_path__ + "static/media/uparrow.2cc77675.svg";